import * as React from 'react';
import { observer } from 'mobx-react';
import { CustomerOrderShortPosition } from '../../stores';
import { Table } from 'react-bootstrap';
import { formatMoney, formatShortDate } from '../../common/Formatting';
import numberToWordsRu from 'number-to-words-ru';

interface IProps {
    data: any;
}

interface IFormData {
    orderNumber: string;
    orderDate: Date;
    sellerName: string;
    customerName: string;
    customerPhone: string;
    payedSum: number;
    positions: CustomerOrderShortPosition[]
}

interface IState {
    payedSum: number
}

@observer
export class ContractOrderForm extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            payedSum: props.data.payedSum
        };
    }

    private formData = this.props.data as IFormData;
    private totalSum = this.formData.positions.reduce((a: number, b) => a + (b.cost * b.count), 0);

    componentDidMount() {
        this.formData = this.props.data as IFormData;
    }

    componentDidUpdate(prevProps: IProps, prevState: any, snapshot: any) {
        if (prevProps.data.payedSum != this.props.data.payedSum) {
            this.setState({
                payedSum: this.props.data.payedSum
            })
        }
    }
    public render() {
        return <div>
            <div>
                <h1 style={{ borderBottom: "2px solid black" }}>Договор-заказ № {this.formData.orderNumber} от {formatShortDate(this.formData.orderDate)}г.</h1>
            </div>
            <br />
            <br />
            <div style={{ paddingLeft: "20px" }}>
                <h4 >
                    Интернет-магазин ABTEKA.RU Интернет Магазин AB61.RU (в дальнейшем именуемый Исполнитель)
                </h4>
            </div>
            <div>
                и
            </div>
            <div style={{ paddingLeft: "20px" }}>
                <h4>
                    {this.formData.customerName}, тел. {this.formData.customerPhone} (в дальнейшем именуемый Клиент)
                </h4>
            </div>
            <br />
            <div>
                заключили настоящий договор о следующем:
            </div>
            <br />
            <div><h6>1. Клиент заказывает детали для автомобиля и вносит залоговую стоимость в размере  ______% от стоимости заказа</h6></div>
            <div><h6>2. Исполнитель выполняет заказ Клиента в срок от 5 до 40 дней с момента внесения залоговой суммы. В отдельных случаях срок исполнения заказа и цены могут быть изменены с обоюдного согласия сторон.</h6></div>
            <div><h6>3. Клиент несет полную ответственность за достоверность указанных технических данных в заказе. Исполнитель не несет ответственность за неверно указанные клиентом сведения в заказе, детали подлежат  возврату только в случае несоответствия заказу.</h6></div>
            <div><h6>4. В случае невозможности поставки заказываемых деталей по независящим от Исполнителя причинам, Исполнитель возвращает залоговую сумму, заранее предупредив Клиента об этом.</h6></div>
            <div><h6>5. Исполнитель принимает детали и возвращает Клиенту деньги, полученные в залог, только в случае обнаружения дефекта в момент передачи Клиенту.</h6></div>
            <div><h6>6. Гарантия на поставляемые детали распространяется при условии установки  в специализированном сервисном центре, имеющем лицензию на проведение данных работ и наличии заключения сервисного центра</h6></div>
            <div><h6>7. В случае отказа Клиента от заказанных деталей сумма залога Клиенту не возвращается.</h6></div>
            <div><h6>8. Основанием для получения заказанных деталей служит настоящий договор-заказ.</h6></div>
            <div><h6>9. Срок хранения заказанных деталей на складе Исполнителя  составляет 45 календарных дней с момента уведомления Клиента. После истечения срока хранения детали остаются в собственности Исполнителя ,сумма залога Клиенту не возвращается.</h6></div>
            <div><h6>10. По взаимному согласию сторон, детали указанные в заказе могут быть заменены на аналогичные без изменения цены.</h6></div>

            <br />
            <br />

            <div className="text-center">
                <h3>Заказываемые детали</h3>
            </div>
            <Table bordered>
                <thead>
                    <tr>
                        <th className="text-center">#</th>
                        <th className="text-center">Артикул</th>
                        <th>Товар</th>
                        <th className="text-center">Количество</th>
                        <th className="text-center">Цена</th>
                        <th className="text-center">Сумма</th>
                    </tr>
                </thead>
                <tbody>
                    {this.formData.positions.map((item, index) => <tr key={index}>
                        <td className="text-center">{index + 1}</td>
                        <td className="text-center">{item.article}</td>
                        <td>{item.description}</td>
                        <td className="text-center">{item.count}</td>
                        <td className="text-center">{formatMoney(item.cost)}</td>
                        <td className="text-center">{formatMoney(item.count * item.cost)}</td>
                    </tr>)}
                </tbody>
                <tfoot>
                    <tr>
                        <td colSpan={5} className="text-right">Итого:</td>
                        <td className="text-center"><strong>{formatMoney(this.totalSum)}</strong></td>
                    </tr>
                </tfoot>
            </Table>
            <br />
            <br />
            <div className="text-left">
                <strong>{numberToWordsRu.convert(this.totalSum)}</strong>
            </div>
            <div>
                <br />
                <br />
                <table style={{ width: "100%" }}>
                    <tr>
                        <td style={{ width: "60%" }}>
                            <h3>Оплачено по заказу</h3>
                        </td>
                        <td>
                            <div className="text-center">
                                <strong>{formatMoney(this.state.payedSum)}</strong>
                            </div>
                            <div className="text-center">
                                <strong>{numberToWordsRu.convert(this.state.payedSum)}</strong>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <h3>Необходимо доплатить по заказу</h3>
                        </td>
                        <td>
                            <div className="text-center">
                                <strong>{formatMoney(this.totalSum - this.state.payedSum)}</strong>
                            </div>
                            <div className="text-center">
                                <strong>{numberToWordsRu.convert(this.totalSum - this.state.payedSum)}</strong>
                            </div>
                        </td>
                    </tr>
                </table>
                <br />
                <br />
                <div style={{ borderBottom: "2px solid black" }}></div>
                <br />
                <br />
                <table style={{ width: "100%" }}>
                    <tr>
                        <td></td>
                        <td style={{ width: "10%" }}>М.П.</td>
                        <td style={{ width: "10%" }}>Исполнитель</td>
                        <td style={{ width: "25%", textAlign: "left", borderBottom: "1px solid black" }}></td>
                        <td style={{ width: "10%" }}></td>
                        <td style={{ width: "20%", paddingRight: "5px" }} className="text-right">Клиент</td>
                        <td style={{ width: "25%", textAlign: "left", borderBottom: "1px solid black" }}></td>
                    </tr>
                </table>
                <br />
                <br />
                <br />
                <table style={{ width: "100%" }}>
                    <tr>
                        <td style={{ width: "45%" }}>Товар получил  &quot;_____&quot; ______________ 20____г</td>
                        <td style={{ width: "10%" }}></td>
                        <td style={{ paddingRight: "5px" }} className="text-right">Клиент</td>
                        <td style={{ width: "25%", textAlign: "left", borderBottom: "1px solid black" }}></td>
                    </tr>
                </table>
            </div>
        </div>;
    }
}
